import { Control } from 'react-hook-form';
import { FormInputText, Grid, RegexMapOptions } from '../../base';
import { ApplyNowFormValues } from '../../common';

import { useTranslation } from 'react-i18next';

interface Props {
    control: Control<any>;
    name: ApplyNowFormValues;
    lastName: ApplyNowFormValues;
    phoneNumber: ApplyNowFormValues;
    email: ApplyNowFormValues;
}

const CandidateForm = (props: Props) => {
    const { control, name, lastName, phoneNumber, email } = props;
    const { t } = useTranslation();
    return (
        <>
            <Grid item md={6} xs={12}>
                <FormInputText
                    name={name}
                    control={control}
                    label={t('applyNow.firstName')}
                    required
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormInputText
                    name={lastName}
                    control={control}
                    label={t('applyNow.lastName')}
                    required
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormInputText
                    name={phoneNumber}
                    control={control}
                    label={t('applyNow.phoneNumber')}
                    required
                    validateExpression={RegexMapOptions.numberOnly}
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormInputText
                    name={email}
                    control={control}
                    label={t('applyNow.email')}
                    required
                />
            </Grid>
        </>
    );
};

export default CandidateForm;
